module.exports = __webpack_public_path__ + "res/Roboto-MediumItalic-webfont.ttf?f52ae9ea752104063e72f1ee633797fe";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-MediumItalic-webfont.ttf
// module id = 84
// module chunks = 0